export default "__VITE_ASSET__Bsivluzr__"